import { render, staticRenderFns } from "./ThankYouLayoutGlass.vue?vue&type=template&id=4ceba6ff&"
import script from "./ThankYouLayoutGlass.vue?vue&type=script&lang=js&"
export * from "./ThankYouLayoutGlass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports